import React from 'react';
import { Card, CardContent, Typography, Button, Stack, Chip } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSelectedContact, setSavedContactDetails } from '../../../actions/contacts/contacts';
import { messagesSetSelectContactMessage, messagesLoading, getContactMessagesByIdContact } from '../../../actions/messages';
import { useToken } from '../../../hooks/useToken';
import { useSelector } from 'react-redux';
import axios from 'axios';

const CardContactMobile = ({ contact }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { contactsMessages } = useSelector(state => state.messages);
    const { getTokenSilent } = useToken();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const handleViewProfile = () => {
        dispatch(setSelectedContact(contact));
        navigate(`/admin/contacts/${contact._id}`);
    };

    const handleViewChat = () => {
        dispatch(setSelectedContact(contact));
        const contactMessage = contactsMessages.find(msg => msg.id_contact === contact._id);
        if (contactMessage) {
            dispatch(messagesSetSelectContactMessage(contactMessage));
        } else {
            dispatch(messagesLoading(true));
            getTokenSilent().then(accessToken => {
                dispatch(getContactMessagesByIdContact(contact._id, accessToken, source, contact.unread_message));
            });
        }
        dispatch(setSavedContactDetails(contact));
        navigate(`/admin/chat`);
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'Sin interacción';
        const date = new Date(dateString);
        return date.toLocaleString('es-MX', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });
    };

    return (
        <Card sx={{ mb: 2, p: 2, borderRadius: 3, boxShadow: 3 }}>
            <CardContent sx={{ p: 0 }}>
                <Typography variant="h6" fontWeight="bold" noWrap>
                    {contact.first_name ? `${contact.first_name} ${contact.last_name || ''}` : 'Sin nombre'}
                </Typography>

                <Typography variant="body2" color="textSecondary" noWrap sx={{ mt: 0.5 }}>
                    Teléfono: {contact.phone}
                </Typography>

                <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 1 }}>
                    Última interacción: {formatDate(contact.message_update)}
                </Typography>

                <Stack direction="row" spacing={1} mt={2} justifyContent="center">
                    <Button
                        size="small"
                        variant="outlined"
                        startIcon={<AccountCircleIcon />}
                        onClick={handleViewProfile}
                    >
                        Perfil
                    </Button>
                    <Button
                        size="small"
                        variant="outlined"
                        startIcon={<ChatIcon />}
                        onClick={handleViewChat}
                        color="success"
                    >
                        Chat
                    </Button>

                    {contact.blocked === false ? (
                        <Chip
                            label="Activo"
                            color="success"
                            size="small"
                            sx={{ height: 24 }}
                        />
                    ) : (
                        <Chip
                            label="Bloqueado"
                            color="error"
                            size="small"
                            sx={{ height: 24 }}
                        />
                    )}
                </Stack>
            </CardContent>
        </Card>
    );
};

export default CardContactMobile;
